/** Merge point/line ArcGIS unique-value rows into one checkbox list (sum counts per type). */
export function mergeProjectFeatureTypes(pointTypes = [], lineTypes = []) {
  const merged = new Map();

  [...pointTypes, ...lineTypes].forEach((item) => {
    if(!item || !item.value || !item.count){
      return;
    }
    const existing = merged.get(item.value);
    if(existing){
      existing.count += item.count;
      return;
    }
    merged.set(item.value, {...item});
  });

  return Array.from(merged.values()).sort((a, b) => {
    return String(a.value).localeCompare(String(b.value), undefined, {sensitivity: 'base'});
  });
}

/** Overall-map checkbox label: feature name + citywide quantity. */
export function formatOverallProjectFeatureLabel({value, count} = {}) {
  if(!value || !count){
    return '';
  }
  return `${value} (${count} citywide)`;
}

export function buildProjectFeatureLayerState(featureTypes) {
  const layerState = {};
  featureTypes.forEach((item) => {
    if(item && item.value && item.count){
      layerState[item.value] = false;
    }
  });
  return layerState;
}

export function featureTypesResponseKind(types = []) {
  const layerMeta = types.find(item => item && item.layer);
  if(layerMeta?.layer?.includes('line')){
    return 'line';
  }
  return 'point';
}
